import React from 'react'
import PropTypes from 'prop-types'
import styles from './_title.css'

function Title (props) {
  const {
    children,
    align,
    color = 'black',
    className = '',
  } = props

  const inlineStyles = { color: color }
  const rulesStyle = { borderColor: color }

  return (
    <h2 className={`${className} ${styles.title} ${styles[`align--${align}`]}`} style={inlineStyles}>
      <hr className={styles.rule} style={rulesStyle} />
      {children}
      <hr className={styles.rule} style={rulesStyle} />
    </h2>
  )
}

Title.propTypes = {
  align: PropTypes.string,
  children: PropTypes.node,
  color: PropTypes.string,
  className: PropTypes.string,
}

export default Title



// WEBPACK FOOTER //
// ./src/components/landing/shared/Title/index.jsx